import * as React from 'react';
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {getTabPermissions} from "@consts/utils";
import {TabPermissions} from "@app-sp/app-shared/shared";
import {Page_Home} from "../pages/Page_Home";
// Not lazy — rendered inline by Page_Unit_Monitoring, so always in that lazy chunk
import {Page_Contacts_iframe} from "../pages/contacts/Page_Contacts_iframe";

// Lazy load all heavy page components
const Page_Unit_Monitoring = React.lazy(() => import("../pages/units/Page_Unit_Monitoring").then(m => ({default: m.Page_Unit_Monitoring})));
const Page_EnvCompare = React.lazy(() => import("../pages/Page_EnvCompare").then(m => ({default: m.Page_EnvCompare})));
const Page_UnitsWrapper = React.lazy(() => import("../pages/units/Page_Units").then(m => ({default: m.Page_UnitsWrapper})));
// Native PM UI — served at /package-manager (nav entry) and at the short /pm path.
const Panel_PM = React.lazy(() => import("../pages/package-manager/native/Panel_PM").then(m => ({default: m.Panel_PM})));
const Page_Overrides = React.lazy(() => import("../pages/overrides/Page_Overrides").then(m => ({default: m.Page_Overrides})));
const Component_RefurbishBackground = React.lazy(() => import("../pages/units/components/Component_RefurbishBackground").then(m => ({default: m.Component_RefurbishBackground})));
const Page_ActivationsList = React.lazy(() => import("../pages/pairing/Page_ActivationsList").then(m => ({default: m.Page_ActivationsList})));
const Page_Activation = React.lazy(() => import("../pages/pairing/Page_Activation").then(m => ({default: m.Page_Activation})));
const Page_BulkActivation = React.lazy(() => import("../pages/pairing/bulk-activation/Page_BulkActivation").then(m => ({default: m.Page_BulkActivation})));
const Page_Admin = React.lazy(() => import("../pages/pairing/Page_Admin").then(m => ({default: m.Page_Admin})));
const Page_TTS = React.lazy(() => import("../pages/tts/Page_TTS").then(m => ({default: m.Page_TTS})));
export const Page_Commands = React.lazy(() => import("../pages/commands/Page_Commands").then(m => ({default: m.Page_Commands})));
const Page_PIIDisposal = React.lazy(() => import("../pages/pii-disposal/Page_PIIDisposal").then(m => ({default: m.Page_PIIDisposal})));

export const Route_Home = "home";
export const Route_PM = "package-manager";
export const Route_PM_Short = "pm";
export const Route_Monitoring = "monitoring";
export const Route_Activation = "activation";
export const Route_ActivationsList = "activation-list";
export const Route_Overrides = "overrides";
export const Route_UnitMonitoring = "unit-monitoring";
export const Route_UnitContact = "unit-contact";
export const Route_UnitRefurbish = "unit-refurbish";
export const Route_EnvCompare = "env-compare";
export const Route_Admin = "admin";
export const Route_TTS = "tts";
export const Route_BulkActivation = "bulk-activation";
export const Route_DSAR = "dsar";
export const Route_Commands = "commands";

export const registerRoutes = () => {
    const tabPermissions = getTabPermissions();
    const hasAdminLevelAccess = tabPermissions.includes(TabPermissions.ADMIN)

    RoutingModule.clearRoutes();

    if (hasAdminLevelAccess || tabPermissions.includes(TabPermissions.PM)) {
        RoutingModule.addRoute(Route_PM, "/package-manager", Panel_PM).setLabel("Package Manager");
        // Same page at /pm (no nav label), so old /pm links keep working. The pm
        // function lives on the /pm-api hosting rewrite so this SPA route is free.
        RoutingModule.addRoute(Route_PM_Short, "/pm", Panel_PM);
    }

    if (hasAdminLevelAccess || tabPermissions.includes(TabPermissions.MONITORING) || tabPermissions.includes(TabPermissions.ACTIVATIONS)) {
        RoutingModule.addRoute(Route_Monitoring, "/monitoring", Page_UnitsWrapper).setLabel("Monitoring");
        RoutingModule.addRoute(Route_UnitContact, "/unit/contact", Page_Contacts_iframe);
        RoutingModule.addRoute(Route_UnitMonitoring, "/unit/monitoring", Page_Unit_Monitoring);
    }

    if (hasAdminLevelAccess || tabPermissions.includes(TabPermissions.ACTIVATIONS)) {
        RoutingModule.addRoute(Route_ActivationsList, "/unit/activations", Page_ActivationsList).setLabel("Activation List");
        RoutingModule.addRoute(Route_UnitRefurbish, "/unit/refurbish", Component_RefurbishBackground);

        RoutingModule.addRoute(Route_BulkActivation, "/unit/activate/bulk", Page_BulkActivation).setLabel("Bulk Activate");
        RoutingModule.addRoute(Route_Activation, "/unit/activate", Page_Activation).setLabel("Activate");
    }

    if (hasAdminLevelAccess || tabPermissions.includes(TabPermissions.TTS)) {
        RoutingModule.addRoute(Route_TTS, "/tts", Page_TTS).setLabel("TTS")
    }

    // Commands full screen: a nav tab, and the target of the unit panel's "open in new tab".
    if (hasAdminLevelAccess || tabPermissions.includes(TabPermissions.COMMANDS))
        RoutingModule.addRoute(Route_Commands, "/commands", Page_Commands).setLabel("Commands");

    if (tabPermissions.includes(TabPermissions.PII_DISPOSAL)) {
        RoutingModule.addRoute(Route_DSAR, "/admin/dsar", Page_PIIDisposal).setLabel("DSAR");
    }

    if (hasAdminLevelAccess) {
        RoutingModule.addRoute(Route_Admin, "/admin", Page_Admin).setLabel("Admin")
        RoutingModule.addRoute(Route_EnvCompare, "/env-compare", Page_EnvCompare);
        RoutingModule.addRoute(Route_Overrides, "/overrides", Page_Overrides);
    }

    RoutingModule.addRoute(Route_Home, "/", Page_Home).setLabel("Home");
};

